import { Set } from "./set.model";
export class Want extends Set {
}